import { render, staticRenderFns } from "./ExchangeCard.vue?vue&type=template&id=5b3d166e"
import script from "./ExchangeCard.vue?vue&type=script&lang=js"
export * from "./ExchangeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports